import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import BlogCard from "./BlogsCards";
import Particle from "../Particle";

import vehicle from "../../Assets/Projects/vehicle.jpeg";
import cassandra from "../../Assets/Projects/cassandra.jpeg";
import baxter from "../../Assets/Projects/baxter.gif";
import eyantra from "../../Assets/Projects/eyantra.jpeg";
import hindi from "../../Assets/Projects/hindi.jpeg";
import person from "../../Assets/Projects/person_id.jpeg";
import explo from "../../Assets/Projects/exploration_vs_exploitation.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={person}
              isBlog={false}
              title="Person Identification and Tracking"
              description="Developed a method using pytorch framework and pretrained network like YOLOv3 and MTCNN to identify and track persons within any organization. One novelity which implemented in this, is to reduce the time complexity of recognition via Unsupervised K-means clustering method"
              keywords="DL, ML, OpenCV, Tracking, pytorch, YOLOv3, MTCNN, K-Means, Siamese-Net, VGGFace"
              link="https://github.com/Amshra267/Exploratory-Project--Person-Identification"
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vehicle}
              isBlog={false}
              title="Unconstrained Indian Vehicle Number Plate Detection"
              description="Build this project along with the help of my team members during a Computer Vision and Machine learning based event Mosaic during Electronics Department Fest UDYAM'21 of IIT BHU sponsored by RapidAI Research Group. Our Approach includes the combination of classical CV techniques and deep learning-based techniques to tackle the problem statement."
              keywords="DL, OpenCV, Haar Cascade, Curve-Smoothing, KCF Tracking"
              link="https://github.com/Amshra267/Mosaic-PS2"
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={baxter}
              isBlog={false}
              title="Simultaneous Multitasking Agent(SMA) Using Deep-RL"
              description="Working on the Problem of training an Agent which mimics human behavior of managing less correlated things simultaneously. I have been working on formulating the problem statement along with the desired MDPs to achieve this task efficiently. This is an ongoing project and not able to share each details, hence for initial working visit homepage from below."
              keywords="RL, DL, MDP, PyBullet, OpenAI-gym, Trajectories"
              link="https://robotics-club-iit-bhu.github.io/RoboReG/projects/simult-multi-agent.html"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eyantra}
              isBlog={false}
              title="E-yantra SankatMochan Bot"
              description=" Project developed during e-yantra Robotics Competition conducted by IIT Bombay, It leveraged the parallel processing power of FPGAs to transverse autonomously on the given arena with the help of perception power from the overhead camera for path planning and optimal control"
              keywords="Verilog, FPGAs, Digital Electronics, Path planning"
              link="https://github.com/Amshra267/E--Yantra-Sankatmochan-Bot-"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cassandra}
              isBlog={false}
              title="Bank loan Repayment Classification and Analysis"
              description="Data Science project developed during the Competition Cassandra organised at UDYAM'21. Approach includes use of LGBM with feature Aggregation on the bank loan repayment data given by H2O.Ai.
              A unique thing in my Approach is that I was able to justify and explain that the training and testing data had very dissimilar distribution which justified the random leaderboard score."
              keywords = "Data Science, Aggregation, Fraud Detection, LGBM, Optuna"
              link="https://github.com/Amshra267/Cassandra-Udyam"
            />
          </Col>
        
        </Row>
        <h1 className="project-heading">
          My Recent <strong className="purple">Blog </strong> Posts
        </h1>
        <p style={{ color: "white" }}>Do give a read to some of my blogs </p>
        <Row style={{ justifyContent: "center" }}>
          <Col md={4} className="blog-card">
            <BlogCard
              imgPath={hindi}
              link="https://akshatsood2249.medium.com/udyam-mosaic-round-1-5a9d7fd23ddb"
              title="Hindi Character Recognition"
              site="medium.com"
            />
          </Col>
          <Col md={4} className="blog-card">
            <BlogCard
              imgPath={explo}
              link="https://amshra267.medium.com/tackling-exploration-exploitation-dilemma-in-k-armed-bandits-598c0329cf88"
              title="Tackling Exploration-Exploitation Dilemma in K-armed Bandits"
              site="medium.com"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
